import Layout from './Layout';
import { useTranslation } from 'react-i18next';

const ChangePassword = ({ openModal }: { openModal: () => void }) => {
	const { t } = useTranslation();

	return (
		<Layout
			variant="ghost"
			parentClass="no-child"
			title={t(`profile.changePassword.title`)}
			description={t(`profile.changePassword.description`)}
			btnText={t(`user.editUser.tabs.changePassword`)}
			handleNext={openModal}
		>
			{null}
		</Layout>
	);
};

export default ChangePassword;
